import React from "react";
import Details from "../components/profile/Details";
import ChangePassword from "../components/companies/profile/changePassword/ChangePassword";

const Profile: React.FC = () => {
  return (
    <div>
      <Details />
      <ChangePassword />
    </div>
  );
};

export default Profile;
